export default __webpack_public_path__ + "static/media/bg-nav-eat-fresh.0cd52231.jpg";